import { useEffect, useRef } from 'react';

export default function MouthpieceComparison() {
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.querySelectorAll('.fade-up, .table-row-anim, .scale-in').forEach((el) => {
              el.classList.add('visible');
            });
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -40px 0px' }
    );

    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="py-20 bg-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2
          className="text-3xl md:text-4xl font-normal text-center text-gray-900 mb-4 fade-up font-serif"
        >
          無料でも、ここが違います。
        </h2>
        <p className="text-center text-gray-600 text-lg mb-16 fade-up">
          「治療を決めるためではなく、比較できる状態をつくるための無料相談です」
        </p>

        <div className="overflow-x-auto scale-in">
          <table className="w-full border-collapse">
            <thead>
              <tr className="bg-gray-50">
                <th className="border border-gray-200 px-6 py-4 text-left font-semibold text-gray-900">比較ポイント</th>
                <th className="border border-gray-200 px-6 py-4 text-center font-semibold text-gray-900">一般的な無料カウンセリング</th>
                <th
                  className="border border-gray-200 px-6 py-4 text-center font-semibold text-white"
                  style={{ backgroundColor: '#3E5F8F' }}
                >
                  当院の比較レポート
                </th>
              </tr>
            </thead>
            <tbody>
              {[
                ['基準', 'ヒアリング中心になりやすい', '診査データに基づく分析'],
                ['提案', '当日その場での提案が中心', 'プラン候補を並べて比較'],
                ['費用・期間', '幅を持った案内になりやすい', '変動要因まで整理して見通しを提示'],
                ['比較', '自分で整理が必要', '資料として残り、自宅で比較できる'],
                ['持ち帰り', '口頭説明やメモが中心', '判断材料としてレポートをお渡し'],
              ].map(([label, general, ours]) => (
                <tr key={label} className="table-row-anim">
                  <td className="border border-gray-200 px-6 py-4 font-medium text-gray-900">{label}</td>
                  <td className="border border-gray-200 px-6 py-4 text-center text-gray-600">{general}</td>
                  <td className="border border-gray-200 px-6 py-4 text-center text-gray-900">{ours}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <p className="text-center text-lg text-gray-700 mt-12 font-medium fade-up">
          持ち帰れる判断材料があるかどうかが違います。
        </p>
      </div>
    </section>
  );
}